import {
  CurrencyExchangeRateResponse,
  WalletsExchangeRatesClient,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const walletsExchangeRatesClient = new WalletsExchangeRatesClient(
  apiConfig,
  undefined,
  axiosInstance
);

export const handleGetExchangeRates = async (): Promise<
  CurrencyExchangeRateResponse | undefined
> => {
  const exchangeRates = (
    await walletsExchangeRatesClient.getCurrencyExchangeRate()
  ).data;
  return exchangeRates;
};
